"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSelectedUserTypes = exports.getVisibleUserTypes = void 0;
const domain_1 = require("@home-health-notify/domain");
const USER_DIRECTORY_TABS_MAP = {
    [domain_1.USER_TYPE.ADMIN]: [
        { userType: domain_1.USER_TYPE.USER, visible: true, defaultSelected: true },
        { userType: domain_1.USER_TYPE.STAFF, visible: true, defaultSelected: true },
    ],
    [domain_1.USER_TYPE.USER]: [
        { userType: domain_1.USER_TYPE.USER, visible: false, defaultSelected: true },
        { userType: domain_1.USER_TYPE.STAFF, visible: false, defaultSelected: true },
        { userType: domain_1.USER_TYPE.ADMIN, visible: true, defaultSelected: true },
    ],
    [domain_1.USER_TYPE.STAFF]: [
        { userType: domain_1.USER_TYPE.USER, visible: true, defaultSelected: true },
        { userType: domain_1.USER_TYPE.STAFF, visible: true, defaultSelected: true },
        { userType: domain_1.USER_TYPE.ADMIN, visible: true, defaultSelected: true },
    ],
};
const getVisibleUserTypes = (loggedInUserType) => {
    return USER_DIRECTORY_TABS_MAP[loggedInUserType]
        .filter(type => type.visible && type.userType)
        .map(type => type.userType);
};
exports.getVisibleUserTypes = getVisibleUserTypes;
const getDefaultSelectedUserTypes = (loggedInUserType) => {
    return USER_DIRECTORY_TABS_MAP[loggedInUserType]
        .filter(type => type.defaultSelected && type.userType)
        .map(type => type.userType);
};
exports.getDefaultSelectedUserTypes = getDefaultSelectedUserTypes;
